module.exports = __webpack_public_path__ + "img/camera.374db37c.png";